var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{staticClass:"table-router-link",attrs:{"to":{ name: 'Card', params: { id: _vm.row.id } },"target":"_blank"}},[_vm._v(" "+_vm._s(_vm.row.info.last_name + ' ' + _vm.row.info.first_name + ' ' + _vm.row.info.middle_name)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }